import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mediaApi } from '@/api/mediaWrapper';
import Image from '@/icons/Image';

interface CitationMediaThumbProps {
  familyId: string;
  mediaAssetId: string;
  onClick?: () => void;
}

const CitationMediaThumb: React.FC<CitationMediaThumbProps> = ({ familyId, mediaAssetId, onClick }) => {
  const { t } = useTranslation('forms');
  const [displayUrl, setDisplayUrl] = useState<string | null>(null);
  const [displayStatus, setDisplayStatus] = useState<'safe' | 'processing' | 'unavailable' | null>(null);

  useEffect(() => {
    let cancelled = false;
    mediaApi.getMediaDisplay(familyId, mediaAssetId, '40x40').then((result) => {
      if (cancelled) return;
      if (result.success && result.data) {
        setDisplayUrl(result.data.url);
        setDisplayStatus(result.data.displayStatus);
      } else {
        setDisplayStatus('unavailable');
      }
    });
    return () => {
      cancelled = true;
    };
  }, [familyId, mediaAssetId]);

  const showImage = displayStatus === 'safe' && displayUrl;
  const isClickable = Boolean(onClick);
  const viewLabel = t('sources.viewCitationImage');

  const content = showImage ? (
    <img src={displayUrl!} alt="" className="sources-citation__thumb-img" loading="lazy" />
  ) : (
    <span className="sources-citation__thumb-placeholder" aria-hidden>
      {displayStatus === 'processing' ? '…' : <Image width={16} height={16} />}
    </span>
  );

  if (isClickable) {
    return (
      <button
        type="button"
        className="sources-citation__thumb sources-citation__thumb--button"
        onClick={onClick}
        title={viewLabel}
        aria-label={viewLabel}
      >
        {content}
      </button>
    );
  }

  return <div className="sources-citation__thumb">{content}</div>;
};

export default CitationMediaThumb;
